module.exports = __webpack_public_path__ + "img/person-icon.64b04190.png";